import { createSlice } from "@reduxjs/toolkit";
import {
    getAllContactFOrmDataEntries,
    deleteContactFormEntry
} from './thunk';

export const initialState = {
    contactFormList: [],
    errors: {}
};

const UsersSlice = createSlice({
    name: 'ContactForm',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // List
        builder.addCase(getAllContactFOrmDataEntries.fulfilled, (state: any, action: any) => {
            state.contactFormList = action.payload;
        });
        builder.addCase(getAllContactFOrmDataEntries.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        
        // Delete
        builder.addCase(deleteContactFormEntry.fulfilled, (state: any, action: any) => {
            state.contactFormList = state.contactFormList.filter((item: any) => item.id !== action.payload);
        });
        builder.addCase(deleteContactFormEntry.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default UsersSlice.reducer;